import { Bus, Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0B0F19] text-slate-300 pt-16 pb-8"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <a href="#acasa" className="inline-flex items-center gap-2">
              <span className="flex items-center justify-center w-9 h-9 rounded-lg bg-amber-500 text-slate-950">
                <Bus className="w-5 h-5" strokeWidth={2.4} />
              </span>
              <span className="font-bold text-lg text-white tracking-tight">
                Global<span className="text-amber-500">Transport</span>
              </span>
            </a>
            <p className="mt-4 text-sm text-slate-400 max-w-md leading-relaxed">
              Servicii de transport persoane și excursii cu plecări din Mangalia
              — pe litoral și în toată țara. Confort, siguranță, punctualitate.
            </p>
          </div>

          <div>
            <div className="text-white font-semibold text-sm uppercase tracking-widest">
              Navigare
            </div>
            <ul className="mt-4 space-y-2 text-sm">
              {[
                ["#acasa", "Acasă"],
                ["#despre", "Despre noi"],
                ["#excursii", "Excursii"],
                ["#preturi", "Rute & Prețuri"],
                ["#recenzii", "Recenzii"],
                ["#rezervare", "Rezervare"],
                ["#contact", "Contact"],
              ].map(([h, l]) => (
                <li key={h}>
                  <a
                    href={h}
                    className="text-slate-400 hover:text-amber-400 transition-colors"
                  >
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="text-white font-semibold text-sm uppercase tracking-widest">
              Contact
            </div>
            <ul className="mt-4 space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <Phone className="w-4 h-4 text-amber-400 mt-0.5" />
                <a
                  href="tel:0742447340"
                  className="hover:text-amber-400 transition-colors"
                >
                  0742 447 340
                </a>
              </li>
              <li className="flex items-start gap-2">
                <Mail className="w-4 h-4 text-amber-400 mt-0.5" />
                <a
                  href="mailto:global.transport.mangalia@gmail.com"
                  className="hover:text-amber-400 transition-colors break-all"
                >
                  global.transport.mangalia@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 text-amber-400 mt-0.5" />
                <span>Mangalia, Constanța</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-slate-800 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 text-xs text-slate-400">
          <div>
            © {new Date().getFullYear()} GlobalTransport. Toate drepturile
            rezervate.
          </div>
          <div>Mangalia · Constanța · Litoralul Mării Negre</div>
        </div>
      </div>
    </footer>
  );
}
